<template>
  <div>
    <h5>{{ $t('Information.addressDetails') }}:</h5>
    <table class="table table-sm mb-4">
      <tr>
        <th scope="row">
          {{ $t('Information.street') }}
        </th>
        <td colspan="2">
          {{ address.street }}
        </td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t('Information.houseNumber') }}
        </th>
        <td colspan="2">
          {{ address.streetNumber }} {{ address.streetNumberSuffix }}
        </td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t("Information.postalCode") }}
        </th>
        <td>{{ address.postalCode }}</td>
        <td>
          <router-link :to="{ name: 'RequestList' }">
            <b-badge
              variant="dark"
              @click="setSearchTerm(search.postalcode)"
            >
              
              <i class="icon fa-fw fal fa-magnifying-glass" />
            </b-badge>
          </router-link>
        </td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t("Information.city") }}
        </th>
        <td>
          {{ address.city }}
        </td>
        <td>
          <router-link :to="{ name: 'RequestList' }">
            <b-badge
              variant="dark"
              @click="setSearchTerm(search.city)"
            >
              
              <i class="icon fa-fw fal fa-magnifying-glass" />
            </b-badge>
          </router-link>
        </td>
      </tr>

      <tr>
        <th>{{ $t('Information.localAuthority') }}</th>
        <td>{{ municipality }}</td>
      </tr>
      <tr>
        <th>{{ $t('Information.coordinates') }}</th>
        <td>{{ lat }}, {{ long }}</td>
      </tr>
    </table>

    <h5>{{ $t('Information.commentsAndOtherInformation') }}</h5>
    <table class="table table-sm mb-4">
      <tr>
        <th scope="row">
          {{ $t('Information.location') }}
        </th>
        <td>{{ additional && additional.location || '-' }}</td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t('Information.comments') }}
        </th>
        <td>{{ remark ? remark : '-' }}</td>
      </tr>
    </table>

    <h5>{{ $t('Information.contactDetails') }}:</h5>
    <table class="table table-sm mb-4">
      <tr>
        <th scope="row">
          {{ $t('Information.name') }}
        </th>
        <td>{{ contactName }}</td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t('Information.phoneNumber') }}
        </th>
        <td>{{ contact.phone || '-' }}</td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t('Information.email') }}
        </th>
        <td>{{ contact.email || '-' }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isObject } from '@/services/validation'
import { getMunicipalityNameByCode } from '@/services/municipalities'
import { getContactNameFromContact } from '@/helpers/common';

export default {
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('requests', [
      'requestCountByNumberplate',
      'requestCountByPostalcode',
      'requestCountByCity',
    ]),
    search() {
      return this.request.search
    },
    address() {
      return this.request.address
    },
    additional() {
      return this.request.additional
    },
    municipality() {
     const municipality = this.address.municipality
      if (isObject(municipality)) {
        return municipality.name
      }
      return (!isNaN(municipality) ? getMunicipalityNameByCode({ code: municipality }) : municipality) || ''
    },
    lat(){
      return this.request.coordinates.lat || '-'
    },
    long() {
      return this.request.coordinates.lng || '-'
    },
    remark() {
      return this.request.remark
    },
    contact() {
      return this.request.contact
    },
    contactName() {
      return getContactNameFromContact(this.contact)
    },
  },
  methods: {
      setSearchTerm(term) {
        const requests = JSON.parse(localStorage.getItem('requests')) || {};
        const updatedRequests = { ...requests, searchTerm: term };
        localStorage.setItem('requests', JSON.stringify(updatedRequests));
      }
    }
}
</script>

<style>
.icon {
  font-size: 0.7rem;
}
</style>
